/* eslint-disable multiline-ternary */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import { PropTypes } from 'prop-types'
import Box from '@mui/material/Box'
import { useDispatch, useSelector } from 'react-redux'
import { PDFDownloadLink, Document, Page } from '@react-pdf/renderer'
import DownloadIcon from '@mui/icons-material/Download'
import {
  setActiveStep,
  setDrawerOpen,
  setProjectInputStep
} from '../../slices/mainTool'
import CustomButton from '../CustomButton'
import { generatePDFDocument } from '../Report/ReportPage'
import { themeConfig } from '../../config/theme.config'
import './SubHeader.scss'
import {
  setManualStreetMode,
  setShareableURL,
  setShowClearSegmentsStartManualModal
} from '../../slices/appSlice'
import { setRoadwayVariables } from '../../slices/generalInputs/roadwayVariables'
import { remixStreet } from '../../../streets/remix'

function SubHeader({
  top = 50,
  left = 30,
  marginTop = 2,
  right = 30,
  className
}) {
  const steps = [
    'Setup Project Manually',
    'Project Setup',
    'Project',
    'Scoring Summary'
  ]
  const { activeStep } = useSelector((state) => state.mainTool)
  const { selectedFeature, shareableURL } = useSelector(
    (state) => state.appSlice
  )
  const dispatch = useDispatch()
  function handleClick() {
    if (activeStep === 0) {
      // When manual mode clicked

      if (selectedFeature) {
        dispatch(setShowClearSegmentsStartManualModal(true))
      } else if (shareableURL) {
        // if sharebale URL and user clicks on setup manually , then set shreable url to false
        dispatch(setShareableURL(false))
        dispatch(setManualStreetMode(true))
      } else {
        dispatch(setManualStreetMode(true))
        dispatch(setDrawerOpen(true))
      }
    } else {
      dispatch(setActiveStep(activeStep - 1))
    }
  }

  const {
    downloadDataUrl,
    showClearSegmentsStartManualModal,
    reportHeaderDataUrl,
    reportTickImgDataUrl,
    reportPedestrialImgUrl,
    reportBicycleImgUrl,
    reportAutoImgUrl,
    reportTransitImgUrl,
    reportFreightImgUrl
  } = useSelector((state) => state.appSlice)
  const {
    pedestrian: pedestrianScore,
    transit: transitScore,
    auto: autoScore,
    freight: freightScore,
    bicycle: bicycleScore
  } = useSelector((state) => state.finalScores)

  const {
    pedestrian: pedestrianWeakestLinkScore,
    transit: transitWeakestLinkScore,
    auto: autoWeakestLinkScore,
    freight: freightWeakestLinkScore,
    bicycle: bicycleWeakestLinkScore
  } = useSelector((state) => state.weakestLinkScores)

  const {
    pedestrian: pedestrianWeakestLinkVariable,
    transit: transitWeakestLinkVariable,
    auto: autoWeakestLinkVariable,
    freight: freightWeakestLinkVariable,
    bicycle: bicycleWeakestLinkVariable
  } = useSelector((state) => state.weakestLinkVariables)

  const {
    Pedestrian: pedestrianTier,
    Transit: transitTier,
    Auto: autoTier,
    Freight: freightTier,
    Bicycle: bicycleTier
  } = useSelector((state) => state.modalTiers)

  const { modalPrioritization } = useSelector((state) => state)
  const { safetyMeasuresArr } = useSelector((state) => state.safetyMeasures)
  const { land_use_context, roadway_name } = useSelector(
    (state) => state.roadwayVariables
  )

  const [allTiers, setAllTiers] = useState(null)
  const [allScores, setAllScores] = useState(null)
  const [allWeakestVariables, setAllWeakestVariables] = useState(null)
  const [allWeaskestScores, setAllWeaskestScores] = useState(null)

  useEffect(() => {
    setAllTiers({
      pedestrianTier,
      transitTier,
      autoTier,
      freightTier,
      bicycleTier
    })
  }, [pedestrianTier, transitTier, autoTier, freightTier, bicycleTier])

  useEffect(() => {
    setAllWeakestVariables({
      pedestrianWeakestLinkVariable,
      transitWeakestLinkVariable,
      autoWeakestLinkVariable,
      freightWeakestLinkVariable,
      bicycleWeakestLinkVariable
    })
  }, [
    pedestrianWeakestLinkVariable,
    transitWeakestLinkVariable,
    autoWeakestLinkVariable,
    freightWeakestLinkVariable,
    bicycleWeakestLinkVariable
  ])

  useEffect(() => {
    setAllWeaskestScores({
      pedestrianWeakestLinkScore,
      transitWeakestLinkScore,
      autoWeakestLinkScore,
      freightWeakestLinkScore,
      bicycleWeakestLinkScore
    })
  }, [
    pedestrianWeakestLinkScore,
    transitWeakestLinkScore,
    autoWeakestLinkScore,
    freightWeakestLinkScore,
    bicycleWeakestLinkScore
  ])
  useEffect(() => {
    setAllScores({
      pedestrianScore,
      transitScore,
      autoScore,
      freightScore,
      bicycleScore
    })
  }, [pedestrianScore, transitScore, autoScore, freightScore, bicycleScore])
  return (
    <Box
      sx={{
        height: activeStep === 0 ? '0px' : '70px'
      }}
    >
      <Box
        className={className}
        sx={[
          {
            position: 'absolute',
            top,
            left,
            zIndex: showClearSegmentsStartManualModal ? 1000 : 100001
          },
          activeStep === 3 ? { top: '62px' } : { top }
        ]}
      >
        <CustomButton
          handleNext={handleClick}
          btnLabel={
            activeStep === 0
              ? `${steps[activeStep]}`
              : `Return to ${steps[activeStep]}`
          }
          iconPlacementLeft={activeStep !== 0}
          withIcon={activeStep !== 0}
          marginTop={activeStep === 3 ? 0 : marginTop}
          justifyContent={activeStep === 3 ? 'flex-start' : 'center'}
          padding={activeStep === 3 ? '10px' : '0px'}
        />
      </Box>
      {activeStep === 3 && (
        <Box
          className="pdfLink"
          sx={[
            {
              position: 'absolute',

              right,
              zIndex: 1050,
              mt: '10px',
              display: 'flex',
              gap: '10px',
              padding: '0.5em 1.5em 0.5em 1.5em',
              fontSize: '14px',
              backgroundColor: themeConfig.semcogGreen,
              borderRadius: '20px',
              fontWeight: 400,
              lineHeight: 1.75,
              justifyContent: 'center',
              width: '200px',
              marginRight: '15px'
            },
            activeStep === 3 ? { top: '62px' } : { top }
          ]}
        >
          <PDFDownloadLink
            document={
              allTiers &&
              allScores &&
              allWeakestVariables &&
              allWeaskestScores &&
              downloadDataUrl &&
              reportHeaderDataUrl &&
              reportTickImgDataUrl &&
              reportPedestrialImgUrl &&
              reportBicycleImgUrl &&
              reportAutoImgUrl &&
              reportTransitImgUrl &&
              reportFreightImgUrl &&
              generatePDFDocument(
                allTiers,
                allScores,
                allWeakestVariables,
                allWeaskestScores,
                downloadDataUrl,
                land_use_context,
                safetyMeasuresArr,
                modalPrioritization,
                reportHeaderDataUrl,
                reportTickImgDataUrl,
                reportPedestrialImgUrl,
                reportBicycleImgUrl,
                reportAutoImgUrl,
                reportTransitImgUrl,
                reportFreightImgUrl
              )
            }
            fileName={roadway_name ? `${roadway_name}_report` : 'report'}
          >
            {({ blob, url, loading, error }) => {
              //  dispatch(setPDFLoading(loading))
              return loading ? (
                'LOADING DOCUMENT...'
              ) : (
                <DownloadReportComponent />
              )
            }}
          </PDFDownloadLink>
        </Box>
      )}
    </Box>
  )
}

function DownloadReportComponent() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        fontFamily: 'Roboto'
      }}
    >
      <DownloadIcon sx={{ color: 'white' }} /> <span>DOWNLOAD REPORT</span>
    </Box>
  )
}

export default SubHeader

SubHeader.propTypes = {
  top: PropTypes.number,
  left: PropTypes.number,
  right: PropTypes.number,
  marginTop: PropTypes.number,
  className: PropTypes.string
}
